<template>
    <div :class="['proPopupContent',contentData!=null ? 'active':'']">
      <div class="insideBox">          
          <span class="xBox">
            <slot></slot>
          </span>
          <div class="contentBox">
              <h5>MIS CLEAR™ Surface</h5>
              <p><strong>The Future is CLEAR</strong></p>
              <p>&nbsp;</p><p>Each MIS LYNX implant is stored in a saline solution, ensuring the implant’s super-hydrophilicity and quality are maintained from production to placement. <sup>1</sup></p><p>&nbsp;</p><p>Bench-testing studies demonstrated that when implants are packaged in a saline solution:</p><p>&nbsp;</p><ul><li>It lowers the carbon levels on the implant surface, compared to “dry” implants. <sup>2</sup></li><li>There is a higher mineralization of Calcium Phosphate (CaP) minerals, compared to “dry” implants. <sup>3</sup></li><li>There is a presence of Titanium Oxide nanostructures on the surface of the implants. <sup>4</sup></li></ul><p>&nbsp;</p><p>&nbsp;</p><div class="ck_content"><strong>MIS CLEAR implants might not be registered or available in every country/region.</strong></div><p>&nbsp;</p><div class="ck_content">1 A surface is super-hydrophilic if the contact angle of a liquid droplet on a solid surface is equal to zero degrees. Data on file (Sessile drop contact angle bench testing) &nbsp;</div><div class="ck_content">2 Data on file (Bench testing using X-ray Photoelectron Spectroscopy (XPS) analysis comparing wet- and dry- packaged implants).</div><div class="ck_content">3 Data on file (Bench testing using a Scanning Electron Microscope (SEM) equipped with elemental analysis comparing wet- and dry-packaged implants).</div><div class="ck_content">4 Data on file (Bench testing using High Resolution Scanning Electron Microscope (HR-SEM) and Raman spectroscopy comparing wet- and dry-packaged implants)</div>             
          </div>          
      </div>
    </div>
</template>

<style>
    .proPopupContent
    {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: hsla(0, 0%, 100%, .8);
        z-index: 9999;      
        display: none;
    }
    .proPopupContent.active
    {
        display: block;
    }

    .proPopupContent .insideBox
    {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        box-shadow: 0 0 40px rgba(45, 45, 45, .1);
        width: 85vw;
        height: 85vh;      
    }
    .proPopupContent .xBox
    {
      z-index: 1001;
      position: absolute;
      top: 20px;
      right: 20px;      
      cursor: pointer;
      width: 30px;
      text-align: center;
    }
    .proPopupContent .contentBox
    {
      padding: 5vw;
    }
    .proPopupContent .contentBox h5
    {
      font-size: 30px;
      padding-bottom: 20px;
      color: #369cde;
    }
    .proPopupContent .contentBox p
    {
      padding-bottom: 6px;
    }
    .proPopupContent .contentBox ul
    {
      padding-left: 30px;
    }
    
    @media screen and (max-width: 815px)
    {
 
    }

</style>



<script>
  import { mapActions, mapState } from "vuex";  
  export default 
  {
    props:{
        contentData:Object
    },
    components:
    {
    },
    data(){
      return{
        minisite_dictionary:null
      }
    },  
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),
    },
    created()  
    {            
        var vm = this;
    },
    mounted()
    {
        var vm=this;
    },

    methods:
    {
      //...mapActions(["setMinisiteData","setMinisiteDic","xSetPlatform","initRouteByCid","setPageReady"]),
        onClosePopup()
        {
            this.$emit("close");
        }
    }
}
</script>


